import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {LoggedUserService} from '../../../bonding_shared';
import {AbstractGuard} from '../../../bonding_shared/components/abstract-guard';
import {SalesRepElementaryRight} from '../../../bonding_shared/model/dictionary-ids';

@Injectable()
export class SalesRepPreviewGuard extends AbstractGuard {
  constructor(loggedUserService: LoggedUserService, router: Router) {
    super(loggedUserService, router);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkRight(state.url, SalesRepElementaryRight.SALES_REP_VIEW);
  }
}
